import * as ChatActions from '../actions/chatActions';

const defaultState = {
    threads: [],
    users: [],
    messageFiles: [],
    uploadingMessageFiles: [],
    online: true,
    adminInstructors: [],
    flaggedComments: [],
    attachments: [],
    announcements: [],
    settings: [],
    sidebarTab: 'Tickets',
    lectures: [],
    chatSubject: {}
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case ChatActions.SETTINGS_RETRIEVED:
            return {
                ...state,
                settings: action.payload.data
            };
        case 'MESSENGER_SEARCHED':
            return {
                ...state,
                users: action.payload
            }
        case ChatActions.SETTINGS_UPDATED:
            return {
                ...state,
                settings: action.payload.settings
            }
        case 'GOT_CHAT_LECTURES':
            return {
                ...state,
                chatSubject: action.payload
            }
        case ChatActions.INCREASE_UNREAD:
            return {
                ...state,
                threads: state.threads.map(t => {
                    if(t.id === action.payload){
                        return {
                            ...t,
                            unread: t.unread++
                        }
                    }else{
                        return {
                            ...t
                        }
                    }
                })
            };
        case ChatActions.RESET_UNREAD:
            return {
                ...state,
                threads: state.threads.map(t => {
                    if(t.id === action.payload){
                        return {
                            ...t,
                            unread: 0
                        }
                    }else{
                        return {
                            ...t
                        }
                    }
                })
            };
        case ChatActions.SIDEBAR_TAB_SET:
            return {
                ...state,
                sidebarTab: action.payload
            };
        case ChatActions.MESSAGE_FILES_UPLOADING:
            return {
                ...state,
                uploadingMessageFiles: state.uploadingMessageFiles.concat(action.payload)
            }
            
        case ChatActions.THREAD_FIELD_UPDATED:
            return {
                ...state,
                threads: state.threads.map(t => {
                    if(t.id === action.payload.threadId){
                        return {
                            ...t,
                            [action.payload.field]: action.payload.newValue
                        }
                    }else{
                        return {
                            ...t
                        }
                    }
                })
            };
            
        case ChatActions.REPORTED_COMMENTS_GOT:
            return {
                ...state,
                flaggedComments: action.payload.comments
            };
            
        case ChatActions.LOADED_ATTACHMENTS:
            return {
                ...state,
                attachments: action.payload.attachments
            }
            
        case ChatActions.LOADED_INSTRUCTORS:
            return {
                ...state,
                adminInstructors: action.payload.instructors
            };
            
        case ChatActions.LOADED_ANNOUNCEMENTS:
            return {
                ...state,
                announcements: action.payload.announcements
            };
            
        case ChatActions.FILE_DELETED:
            return {
                ...state,
                threads: state.threads.map(t => {
                    if(t.id === action.payload.threadId){
                        return {
                            ...t,
                            Messages: t.Messages.map(m => {
                                if(m.id === action.payload.messageId){
                                    return {
                                    ...m,
                                    MessageFiles: m.MessageFiles.filter(f => f.id !== action.payload.mfId)
                                    }
                                }else{
                                    return {
                                        ...m
                                    }
                                }
                            })
                        }
                    }else{
                        return {
                            ...t
                        }
                    }
                }),
                attachments: state.attachments.filter(f => f.id !== action.payload.mfId)
            }
            
        case ChatActions.REPORT_RESOLVED:
            return {
                ...state,
                flaggedComments: state.flaggedComments.map(m => {
                    if(m.id === action.payload.messageId){
                        return {
                            ...m,
                            content: action.payload.content,
                            reportedBy: m.reportedBy.map(r => {
                                
                                r.status = 'solved';
                                return r;
                            })
                        }
                    }else{
                        return {
                            ...m
                        }
                    }
                }),
                threads: state.threads.map(t => {
                    if(t.id === action.payload.threadId){
                        return {
                            ...t,
                            Messages: t.Messages.map(m => {
                                if(m.id === action.payload.messageId){
                                    return {
                                    ...m,
                                    content: action.payload.content,
                                    reportedBy: m.reportedBy.map(r => {
                                                r.status = 'solved';
                                                return r;
                                            })
                                        }
                                    }else{
                                        return {
                                            ...m
                                        }
                                    }
                            })
                        }
                    }else{
                        return {
                            ...t
                        }
                    }
                })
            }
            
        case ChatActions.ANNOUNCEMENT_DELETED:
            return {
                ...state,
                threads: state.threads.map(t => {
                    if(t.id === action.payload.threadId){
                        return {
                            ...t,
                            Messages: t.Messages.filter(m => m.id !== action.payload.id)
                        }
                    }else{
                        return {
                            ...t
                        }
                    }
                }),
                announcements: state.announcements.filter(m => m.id !== action.payload.id)
            }
            
        case ChatActions.MESSAGE_UPDATED:
            
            return {
                ...state,
                threads: state.threads.map(t => {
                    if(t.id === action.payload.threadId){
                        return {
                            ...t,
                            Messages: t.Messages.map(m => {
                                if(m.id === action.payload.messageId){
                                    return {
                                        ...m,
                                        [action.payload.field]: action.payload.newValue
                                    }
                                }else{
                                    return {
                                        ...m
                                    }
                                }
                            })
                        }
                    }else{
                        return {
                            ...t
                        }
                    }
                })
            };
        case ChatActions.LOADED_THREAD_FILES:
            return {
                ...state,
                threads: state.threads.map(t => {
                    if(t.id === action.payload.threadId){
                        return {
                            ...t,
                            ThreadFiles: action.payload.files
                        }
                    }else{
                        return {
                            ...t
                        }
                    }
                })
            }
            
        case ChatActions.STATUS_CHANGE:
            return {
                ...state,
                online: (action.payload.data.profileId === action.payload.profileId) ? action.payload.data.online : state.online,
                threads: state.threads.map(t => {
                    return {
                        ...t,
                        Profiles: t.Profiles.map(p => {
                            if(p.id === action.payload.data.profileId){
                                return {
                                    ...p,
                                    online: action.payload.data.online
                                }
                            }else{
                                return {
                                    ...p
                                }
                            }
                        })
                    }
                })
            }
        case ChatActions.CLEAR_MESSAGE_FILES:
            return {
                ...state,
                messageFiles: [],
                uploadingMessageFiles: []
            }
        case ChatActions.MESSAGE_FILES_UPLOADED: 
            return {
                ...state,
                messageFiles: state.messageFiles.concat(action.payload),
                uploadingMessageFiles: []
            }
        case ChatActions.MESSAGE_FILE_DELETED:

            return {
                ...state,
                messageFiles: state.messageFiles.filter(f => f.id !== action.payload.id)
            }
        case ChatActions.MESSAGE_ADDED:
            return {
                ...state,
                threads: state.threads.map(t => {
                    if(t.id === action.payload.threadId){
                        return {
                            ...t,
                            Messages: (t.Messages) ? t.Messages.concat(action.payload) : [action.payload],
                            lastActivity: new Date()
                        }
                    }else{
                        return {
                            ...t
                        }
                    }
                }).sort((a, b) => new Date(b.lastActivity) - new Date(a.lastActivity))
            };
        case ChatActions.ANNOUNCEMENT_ADDED:
            return {
                ...state,
                threads: state.threads.map(t => {
                    if(t.id === action.payload.message.threadId){
                        return {
                            ...t,
                            Messages: (t.Messages) ? t.Messages.concat(action.payload) : [action.payload],
                        }
                    }else{
                        return {
                            ...t
                        }
                    }
                }),
                announcements: state.announcements.concat(action.payload.message)
            };
            
        case ChatActions.TICKET_SOLVED:
            return {
                ...state,
                threads: state.threads.map(t => {
                    if(t.id === action.payload.id){
                        return {
                            ...t,
                            solved: true
                        }
                    }else{
                        return {
                            ...t
                        }
                    }
                })
            };
        case ChatActions.TICKET_CLOSED:
            return {
                ...state,
                threads: state.threads.map(t => {
                    if(t.id === action.payload.id){
                        return {
                            ...t,
                            closed: true
                        }
                    }else{
                        return {
                            ...t
                        }
                    }
                })
            };
        case ChatActions.MESSAGE_PREPEND:
            return {
                ...state,
                threads: state.threads.map(t => {
                    if(t.id === action.payload[0].threadId){
                        let messages = action.payload.concat(t.Messages);
                        return {
                            ...t,
                            Messages: messages
                        }
                    }else{
                        return {
                            ...t
                        }
                    }
                })
            };
        case ChatActions.THREAD_CREATED:
            return {
                ...state,
                threads: state.threads.concat(action.payload)
            };
        case ChatActions.THREAD_UPDATED:
            let exists = state.threads.filter(t => t.id === action.payload.id);
            let threads = state.threads;
            
            if(exists.length > 0){
                threads = state.threads.map(t => {
                    if(t.id === action.payload.id){
                        return {
                            ...t,
                            users: action.payload.users,
                            Messages: (action.payload.userShouldGetFullThread === action.payload.myprofileId) ? action.payload.Messages : t.Messages
                        }
                    }else{
                        return {
                            ...t
                        }
                    }
                })
            }else{
                threads.push(action.payload);
            }
            return {
                ...state,
                threads: threads
            };
        case ChatActions.USERS_RETRIEVED:
            return {
                ...state,
                users: action.payload
            };
        case ChatActions.INITIAL_THREADS:
            return {
                ...state,
                threads: action.payload.sort((a, b) => new Date(b.lastActivity) - new Date(a.lastActivity))
            };
        case ChatActions.IS_TYPING:
            return {
                ...state,
                threads: state.threads.map(t => {
                    if(t.id == action.payload.threadId){
                        return {
                            ...t,
                            typing: action.payload.typing
                        }
                    }else{
                        return {
                            ...t
                        }
                    }
                })
            };
        case ChatActions.MESSAGE_SEEN:
            return {
                ...state,
                threads: state.threads.map(t => {
                    if(t.id == action.payload.threadId){
                        return {
                            ...t,
                            Messages: t.Messages.map(m => {
                                if(m.id == action.payload.messageId){
                                    return {
                                        ...m,
                                        seenBy: action.payload.seenBy
                                    }
                                }else{
                                    return {
                                        ...m
                                    }
                                }
                            })
                            
                        }
                    }else{
                        return {
                            ...t
                        }
                    }
                })
            };
            
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/chatReducer.js